import React, { useContext } from 'react';

import { Grid, Typography } from '@mui/material';
import { Screen } from '../../components';
import { makeStyles } from '@mui/styles';
import MetricCard from '../../components/MetricCard/MetricCard';
import { PatientListsCards } from './components';
import { UserContext } from '../../lib/contexts';
import { ThemeContext } from '../../lib/contexts';
import { useFlags } from 'launchdarkly-react-client-sdk';

const useStyles = makeStyles((theme) => ({
  screen: {
    width: '96%',
    margin: '10px auto auto',
  },
  dashboard: {
    width: '92%',
    margin: 'auto',
    '& h2': {
      width: '100%',
      fontSize: 20,
      marginTop: 20,
      marginBottom: 20,
      color: theme.palette.admin.main,
      display: 'block',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  patientLists: {
    marginTop: 20,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  welcomeText: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  titleText: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  overviewOptionsGrid: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  overviewInfoGrid: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
}));

const DashboardScreen = () => {
  const classes = useStyles();
  const {
    state: { first_name },
  } = useContext(UserContext);
  const { primaryColor } = useContext(ThemeContext);
  // console.log('primaryColor: ', primaryColor);
  //const devMode = ['localhost', 'dev'].includes(process.env.REACT_APP_SYSTEM_ENV);
  // console.log('here is userConext: ', useContext(UserContext))
  const flags = useFlags();

  return (
    <Screen
      title={'Dashboard - Diet ID'}
      showSidebarNav={true}
      admin={true}
    >
      <Grid
        container
        alignItems="center"
        spacing={0}
        className={classes.screen}
      >
        <Typography
          variant={'subtitle1'}
          className={classes.welcomeText}
        >
          Welcome, {first_name && first_name + ','} to your Diet ID Dashboard
          {/* This is just a silly example of how to use Launch Darkly for feature flagging. */}
          {flags.exclamationPoint ? '!' : ''}
        </Typography>
        <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          spacing={0}
          className={classes.dashboard}
        >
          <Typography
            variant={'h2'}
            color={'primary'}
            className={classes.titleText}
          >
            Overview
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
            // marginLeft={3}
            className={classes.overviewOptionsGrid}
          >
            <MetricCard slug={'avg_completion_time'} />
            <MetricCard slug={'avg_diet_quality'} />
            <MetricCard slug={'total_assessments_to_review'} />
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
            className={classes.overviewInfoGrid}
          >
            <MetricCard slug={'total_users'} />
            <MetricCard slug={'total_new_messages'} />
          </Grid>

          <Typography
            variant={'h2'}
            color={'primary'}
          >
            Quick Access Patient Lists
          </Typography>
          <Grid
            container
            item
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
            className={classes.patientLists}
          >
            <PatientListsCards />
          </Grid>
        </Grid>
      </Grid>
    </Screen>
  );
};

export default DashboardScreen;
